var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckOutlineIcon = function SvgCheckOutlineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.717 6.866-2.6-2.6a.4.4 0 0 1 0-.566l.566-.566a.4.4 0 0 1 .566 0L3 4.886l3.751-3.752a.4.4 0 0 1 .566 0l.566.566a.4.4 0 0 1 0 .566l-4.6 4.6a.4.4 0 0 1-.566 0Z",
    fill: "currentColor"
  })));
};
export default SvgCheckOutlineIcon;